import React, { useEffect, useRef, useState } from 'react';
import datacoLogo from '../../Assets/dataco_logo-NEW.png';
import {
    COMPLETE_PROGRESS,
    COMPLETION_HOLD_MS,
    INITIAL_PROGRESS,
    LONG_REQUEST_THRESHOLD_MS,
    PROGRESS_INTERVAL_MS,
    getLoadingDisplay,
    getNextProgress,
} from './progress';
import '../../Assets/DatacoLoadingIndicator.css';

export default function DatacoLoadingIndicator({
    loading = true,
    variant = 'inline',
    size = 'standard',
    label = 'Loading',
    className = '',
}) {
    const [progress, setProgress] = useState(INITIAL_PROGRESS);
    const [visible, setVisible] = useState(Boolean(loading));
    const [isLongRunning, setIsLongRunning] = useState(false);
    const intervalRef = useRef(null);
    const completionRef = useRef(null);
    const longRequestRef = useRef(null);

    useEffect(() => {
        clearInterval(intervalRef.current);
        clearTimeout(completionRef.current);
        clearTimeout(longRequestRef.current);

        if (loading) {
            setVisible(true);
            setProgress(INITIAL_PROGRESS);
            setIsLongRunning(false);
            intervalRef.current = setInterval(() => {
                setProgress((current) => getNextProgress(current));
            }, PROGRESS_INTERVAL_MS);
            longRequestRef.current = setTimeout(() => {
                setIsLongRunning(true);
            }, LONG_REQUEST_THRESHOLD_MS);
        } else if (visible) {
            setIsLongRunning(false);
            setProgress(COMPLETE_PROGRESS);
            completionRef.current = setTimeout(() => {
                setVisible(false);
            }, COMPLETION_HOLD_MS);
        }

        return () => {
            clearInterval(intervalRef.current);
            clearTimeout(completionRef.current);
            clearTimeout(longRequestRef.current);
        };
    }, [loading]);

    if (!visible) return null;

    const classes = [
        'dataco-loading-indicator',
        `dataco-loading-indicator--${variant}`,
        `dataco-loading-indicator--${size}`,
        className,
    ].filter(Boolean).join(' ');

    return (
        <div className={classes} role="status" aria-live="polite" aria-busy={visible}>
            <div className="dataco-loading-indicator__logo-wrap" aria-hidden="true">
                <img
                    className="dataco-loading-indicator__logo dataco-loading-indicator__logo--grayscale"
                    src={datacoLogo}
                    alt=""
                />
                <img
                    className="dataco-loading-indicator__logo dataco-loading-indicator__logo--color"
                    src={datacoLogo}
                    alt=""
                    style={{ clipPath: `inset(0 0 ${100 - progress}% 0)` }}
                />
            </div>
            <div className="dataco-loading-indicator__percentage">
                {getLoadingDisplay(progress, isLongRunning)}
            </div>
            <span className="visually-hidden">{label}</span>
        </div>
    );
}
